import * as preact from "preact";

interface Props {
  href: string;
  icon: string;
  title: string;
  testID?: string;
}

/** A big button starting practice (flashcards, or a conversation) */
export default class PracticeButton extends preact.Component<Props> {
  render() {
    const { href, icon, title, testID } = this.props;
    return (
      <a class="practiceButton" href={href} data-testid={testID}>
        <span class="buttonIcon">
          <img src={icon} alt="" />
        </span>
        <span class="buttonTitle">{title}</span>
      </a>
    );
  }
}
